import React from "react";
import { useNavigate } from "react-router-dom";
import { useUI } from "../UIContext";

export default function AskOIM({ question, source, label = "Ask OIM" }) {
  const nav = useNavigate();
  const { askOIM } = useUI();
  return (
    <button
      className="ask-oim"
      onClick={(e) => {
        e.stopPropagation();
        askOIM(question, source);
        nav("/advisor");
      }}
      data-testid={`ask-oim-${(question || "").slice(0, 24).replace(/[^a-z0-9]/gi, "-").toLowerCase()}`}
    >
      {label}
    </button>
  );
}
